import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '<',
        update: '&',
        selectedItems: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'report.Mark as completed' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div ng-if="vm.hasDifferentCourses()" class="alert alert-warn">
                {{ 'report.Warning! You are about to mark outside the system passings for multiple different courses' | translate }}
            </div>
            <div ng-if="vm.errors.length" class="alert alert-danger">
                <span ng-repeat="error in vm.errors">
                    {{ error }}</br>
                </span>
            </div>
            <reports-courseprogress-table modal-view="true" selected-items="vm.selectedItems" items="vm.selectedItems"/>
            <form-wrapper class="form" form="vm.datePassed">
                <form-row error="vm.datePassedError">
                    <label class="label">{{ 'report.Date passed' | translate }}</label>
                    <div class="items">
                        <datepicker-api ng-model="vm.datePassed"></datepicker-api>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li ng-if="vm.datePassed" class="primary">
                    <button class="btn main" type="button" ng-click="vm.submit()">
                        {{ 'courses.Mark as passed' | translate }}
                    </button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, toastr, moment, MomentService, ModalService, OccurrenceResource) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.moment = moment;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.OccurrenceResource = OccurrenceResource;
    }

    $onInit () {
        this.datePassedError = null;
    }

    validateDatePassed () {
        this.datePassedError = null;

        if (!this.MomentService.isPassedDate(this.datePassed) && !this.MomentService.isCurrentDate(this.datePassed)) {
            this.datePassedError = this.$translate.instant('reports.Date passed can not be future date');
        }
    }

    submit () {
        this.validateDatePassed();
        if (!this.datePassedError) {
            const message = this.$translate.instant(
                'reports.mark_done_confirm_message'
            );
            this.ModalService.confirm(message, 'medium').then(() => {
                this.errors = [];
                const time = this.moment().format('HH:mm:ss');
                this.OccurrenceResource.setPassedCourses(this.constructFormModel(time)).$promise
                    .then(() => this.uibModalInstance.close())
                    .catch((errors) => {
                        this.errors = [];
                        if (this.lodash.isEmpty(errors.data) || !Array.isArray(errors.data)) {
                            return;
                        }
                        this.errors = errors.data.reduce((original, error) => {
                            original.push(error.message);
                            return original;
                        }, []);
                    });
            });
        }
    }

    constructFormModel (time) {
        return this.selectedItems.map((item) => ({
            occurrenceId: item.occurrenceId,
            userId: item.userId,
            dateTimePassed: this.MomentService.convertToTimezone(`${this.datePassed} ${time}`, 'UTC')
        }));
    }

    hasDifferentCourses () {
        return [...new Set(this.selectedItems.map((item) => item.courseId))].length > 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/report/courseprogress/complete/index.js